import React from 'react';
import PropTypes from 'prop-types';
import { Title } from '@common/components';
import { useTranslation } from 'react-i18next';
import DayDetailBody from '@dashboard/components/SyncMonitor/DayDetailBody';
import classes from './SyncDayDrawer.module.scss';

export default function SyncDayDrawer({ isOpen, onClose, centerId, date }) {
  const { t } = useTranslation('dashboard\\SyncMonitorView', {
    useSuspense: false,
  });

  if (!isOpen) return null;

  return (
    <div className={classes.panelContent}>
      <div className={classes.panelHeader}>
        <Title type="h2" color="primary">
          {t('drawerTitle')}
        </Title>
        <button
          type="button"
          className={classes.closeBtn}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>

      <DayDetailBody centerId={centerId} date={date} showMeta />
    </div>
  );
}

SyncDayDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  centerId: PropTypes.string,
  date: PropTypes.string,
};
